/*
 * Wizard progress
*/

rs.module("controls/navigation/wizard-progress",

    [
        "layouts/site-shell"
    ],

    function (siteShell) {

        //
        // Initialize bubble style progress
        //
        function initializeBubbles(jsSelectors, requestedStepGap) {

            var wizardSelector = `[data-wizard='${jsSelectors.wizard}']`;
            var wizardDiv = $(wizardSelector);

            var progressDiv = wizardDiv.js(jsSelectors.progress);
            var stepDivs = progressDiv.js(jsSelectors.step, { multiple: true });
            var stepCount = stepDivs.length;
            var stepLabels = progressDiv.js(jsSelectors.label, { multiple: true });

            var initialStepWidth = progressDiv[0].style.getPropertyValue("--progress-step-width");
            var initialStepGap = progressDiv[0].style.getPropertyValue("--progress-step-gap");

            // This is the minimum gap we are cool with having between steps, after that it's too smashed
            var minimumStepGap = 20;

            // We also want to make sure if there are only 2 or 3 steps they stay ideally spread out a little bit
            var minimumIdealOverallWidth = (stepDivs.length == 2 ? 175 : stepDivs.length == 3 ? 300 : 0);

            // This is the smallest we are willing to shrink our label text down to
            var minimumLabelWidth = 38;

            // Update the sizing now, and anytime we get resized
            updateSizing();
            siteShell.contentAreaResized(updateSizing);

            // Update the sizing of the bubble widths and gaps for the ideal fit in the available space
            function updateSizing() {

                var availableWidth = wizardDiv.parent().width();

                // We need to put the label texts all back to full length, and the widths and gaps back to there most compact spacing, before starting any calculations
                stepLabels.width("auto");
                stepLabels.removeAttr("title");
                progressDiv[0].style.setProperty('--progress-step-width', initialStepWidth);
                progressDiv[0].style.setProperty('--progress-step-gap', initialStepGap);

                // The extra space we have available between the end of the bubbles and the container  Could be negative if we don't have enough space.
                var freeSpace = availableWidth - requiredOverallWidth();

                // Start out assuming we'll end up using the default minimum step gap
                var stepGap = minimumStepGap;

                // If we require more space than we have, then shrink the labels as much as we can
                if (freeSpace < 0) {
                    shrinkLabels(availableWidth);
                }

                // If we have some extra space to play with...
                else if (freeSpace > 0) {

                    // We have more space than we need so we can try to honor the users requested step gap (if any) and our minimum ideal overall width (to
                    // make sure wizards with only 2 or 3 bubbles aren't so smashed looking)
                    stepGap = increaseStepGap(availableWidth, freeSpace);
                }

                // We can finally set the width and gap
                progressDiv[0].style.setProperty('--progress-step-width', determineStepWidth() + "px");
                progressDiv[0].style.setProperty('--progress-step-gap', stepGap + "px");

                // Get the left-most child of the stepDiv (this will either be the bubble or the label, whichever is leftmost depending on the
                // length of the label)
                var left = stepDivs.first().children().toArray().reduce((previous, current) => Math.min(previous, Number($(current).position().left)), Number.MAX_SAFE_INTEGER);

                // Move the progress div container over so that the left-most edge of the first step is at the zero position
                progressDiv[0].style.setProperty('--progress-offset', -left + "px");
            }

            // The minimum overall required width for all the steps, based on minimum step gap and the current label sizing
            function requiredOverallWidth() {

                // Determine the width of each step based on the current label sizing
                var stepWidth = determineStepWidth();

                // How much space does this take up with that width and the minimum gap
                return (stepWidth * stepCount) + (minimumStepGap * (stepCount - 1));
            }

            // Shrink the labels little by little until we can hopefuly fit into the available space
            function shrinkLabels(availableWidth) {

                // Keep going while we are still too big
                while (requiredOverallWidth() > availableWidth) {

                    // If there is no more room to shrink we bail
                    if (!shrinkLongestLabel()) {
                        break;
                    }
                }
            }

            // Shrink the longest label we have.  If it's already as small as it can get, return false.
            function shrinkLongestLabel() {

                var longestLabel = $(stepLabels.toArray().toSorted((left, right) => $(right).width() - $(left).width())[0]);

                // Already too small, 
                if (longestLabel.width() <= minimumLabelWidth) {
                    return false;
                }
                else {
                    // Shrink by 1px. We have to shrink little by little until we fit
                    longestLabel.width(longestLabel.width() - 1);

                    // With it shrunk, give it a title so user can see the full text on hover
                    longestLabel.attr("title", longestLabel.js(jsSelectors.labelText).text().trim());

                    // Success
                    return true;
                }
            }

            // Calculate an increased step gap so we can try to honor the users requested step gap (if any) and our minimum ideal overall width (to
            // make sure wizards with only 2 or 3 bubbles aren't so smashed looking)
            function increaseStepGap(availableWidth, freeSpace) {

                // Start out assuming the gap is just the minimum
                var stepGap = minimumStepGap;

                // If the user had a requested gap size, honor as much of it as we can
                if (requestedStepGap && requestedStepGap > minimumStepGap) {

                    // This is the maximum amount of step gap we have extra room for
                    var maximumStepGap = minimumStepGap + (freeSpace / (stepCount - 1));

                    // Update to the users request, up to the maximum we have room for
                    stepGap = Math.min(maximumStepGap, requestedStepGap);

                    // Update our free space by subtracting out what we added to the stepGap
                    freeSpace -= (stepGap - minimumStepGap) * (stepCount - 1);
                }

                // Our updated overall width with the adjusted stepGap
                var overallWidth = availableWidth - freeSpace;

                // If our overall width is less than minimally ideal, and we still have free space, bump up the gap to hit the ideal width
                if (overallWidth < minimumIdealOverallWidth && freeSpace > 0) {

                    // How much we want to grow our overall width by
                    var expandBy = Math.min(minimumIdealOverallWidth - overallWidth, freeSpace);

                    // The gap just increases evenly based on how much to expand
                    stepGap += expandBy / (stepCount - 1);
                }

                return stepGap;
            }

            // Calculate the minimum required width to apply to the steps, based on the current state\visiblity of the labels
            function determineStepWidth() {

                // We can't just take the largest step width.  Since each step has a different width (due to the label sizing), the width we really
                // need is the largest center-to-center spacing.
                var centerToCenter = 0;
                for (var stepIndex = 0; stepIndex < stepDivs.length - 1; stepIndex++) {
                    var left = $(stepDivs[stepIndex]);
                    var right = $(stepDivs[stepIndex + 1]);

                    centerToCenter = Math.max(centerToCenter, (left.width() / 2) + (right.width() / 2));
                }

                return centerToCenter;
            }
        }

        //
        // Initialize bar style progress
        //
        function initializeBar(jsSelectors, cssClasses) {
            // On render, we start the mobile progress bar at the previous step's fill width (using _next or _back).
            // We immediately remove those classes to transition the bar to the current step 
            // - set timeout with a 0s delay is needed to trigger the transition otherwise we remove the class so fast it doesn't transition
            setTimeout(function () {
                var progressBarFill = $.js(jsSelectors.progressBarFill);
                var fillText = progressBarFill.js(jsSelectors.progressBarFillText);

                if (progressBarFill.hasClass(`${cssClasses.back}`) || progressBarFill.hasClass(`${cssClasses.next}`)) {

                    progressBarFill.removeClass(`${cssClasses.back} ${cssClasses.next}`).one("transitionend", function () {
                        // evaluate if the fill text will fit inside the fill bar - if not, don't show it
                        fillText.toggleClass(cssClasses.visible, fillText.width() < $(this).width());
                    });
                }
                else {
                    // if we aren't transitioning we still want to show/hide the text, we just don't need to wait for transition end
                    fillText.toggleClass(cssClasses.visible, fillText.width() < $(this).width());
                }

            }, 0);
        }

        // Exported public API
        var exports = {
            initializeBubbles,
            initializeBar
        };

        return exports;
    }
);